/* **********************************************************************************************************
**** docTreeService : service written to edit doc tree ******
********************************************************************************************************** */
(function(){
    angular.module('ui2.0Service')
        .service('docTreeService', docTreeService);

    function docTreeService($http, $compile, $timeout,$modal,$rootScope,dataManipulationService) {
        var self = this;
        var docPostJsonKeyMap = {
            'filekey': 'key',
            'fileAction': 'cdAction',
            'id': 'id'
        };
        this.uploadLink = [{
            'linkName': '',
            'link': ''
        }];

        this.hovered = {};
        this.linkNameFlag = false;
        this.showDoctreeTemplate = false;
        this.otherFolder = false;
        this.showImportFromCdr = false;
        this.cdrToContractPorting = false;
        this.baseCdrToContractDocMovementField = [{
            "id":999999,
            "type":"text",
            "layoutURL":"/listRenderer/list/409/defaultUserListMetaData/",
            "orderSeq":100,
            "properties":{
                "addDefaultParameters":{
                     "docFlowType":"moveToTree"
                }
            },
            "displayMode":"display",
            "dataURL":"/listRenderer/list/409/tablistdata/",
            "dynamicField":false,
            "editableHtmlType":1,
            "autoComplete":false,
            "enableListView":false,
            "bulkEditable":false
        }]
        this.importedDocsFromCdr = [];
        this.uploadDocLayout = '';
        this.showfileaction = false;
        this.selectedTileArray = [];
        this.showCustomNumbering = false;
        this.showFileProperties = false;
        this.downloadContractDocOption = false;
        this.deleteItemOption = false;
        this.customNumberingProps = {};
        this.showReplace = false;
        this.showRename = false;
        this.showUploadChild = false;
        this.uploadDocPropName= [];
        this.uploadDocProp = [];
        this.uploadDocPropCopy =[];
        this.newlyAppendFileList = [];
        this.hasAutoExtractEntitiesPermission = false;
        this.hiddenUploadDocPropName = ["totalPages", "startPageNumber", "numberOfPagesToExclude"];
        this.customNumberingFields = ["numberOfPagesToExclude","startPageNumber","totalPages"];
        this.allowedExtForCustomNumbering = ['pdf','xps','doc','docx','dot','docm','dotm','dotx','gdoc'];
        this.fpmodalOpen = false;
        this.saveFpProp = false;
        this.isPropertiesValid = true;
        this.docUploadFlow = false;
        this.replacedFileObj = [];
        this.lastUploadScope = null;
        this.shouldAppendUploadedFilesOnModalClose = false;

        /************************************ || BEGINNING OF PUBLIC FUNCTIONS || **************************************/
        this.getUploadFormScope = function () {
            var scope = self.uploadScope || self.lastUploadScope;
            if (!scope || !scope.globalData || !scope.globalData.dynamicFormId) {
                scope = angular.element('ng-view').scope();
            }
            return scope;
        };
        this.updateDocListInReact = function($scope,docList) {
            if (!$scope || !$scope.globalData || !$scope.globalData.dynamicFormId) {
                return;
            }
            let newFormData = {
                files: docList,
                actionType:"updateDocList"
            }
            window.sarc.channelBroadcast("reactDynamicForms",newFormData,`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
        };
        this.syncContractDocumentsToReact = function (docList) {
            self.updateDocListInReact(self.getUploadFormScope(), docList);
        };
        this.bulkNovation=function(e){
            window.sarc.channelBroadcast("docTreeChannel", {
                actionType: "bulkNovation",
                payload:e
            }, 'docTreeChannelSubscription')
        }
        this.toggleDocTreeBulkDD = function(val) {
            $('ng-view').scope().showDocTreeBulkDD = !val;
        }
        this.updateBulkFileProperties = function (arr,e) {
            window.sarc.channelBroadcast("docTreeChannel", {
                actionType: "bulkFilePropertiesUpload",
                payload: arr
            }, 'docTreeChannelSubscription');
            let editedFileProperties = arr.filter(item => item.selected != 'n/a');
            if(editedFileProperties.length) {
                $('ng-view').scope().showDocTreeBulkDD = false;
                $('ng-view').scope().showEditButton.enabled = true;
            }
            return this.cancelBulkAction(e,"external");
        }
        this.cancelBulkAction=function(e,scpParam){
            e && e.stopPropagation();
            var scp=$('ng-view').scope();
            if(scpParam === "external"){
                scp.internal=false;
            }
            if($rootScope.hasBulkFilePropertiesPermission && !$rootScope.hasBulkNovationPermission){
                scp.external=false;
            }
            scp[scpParam]=false;
            $timeout(()=>{
                scp.$apply()
            })
            return this.getPropArray();
        }
        this.getPropArray = function () {
            let arr =  [
                {
                    id:"70",
                    label: intl_msg[4569],
                    selected: 'n/a',
                    name: 'viewerAvailable',
                    docSpecific: true},
                {
                    id:"71",
                    label: intl_msg[4570],
                    selected: 'n/a',
                    name: 'search',
                    docSpecific: false},
                {
                    id:"72",
                    label: intl_msg[4565],
                    selected: 'n/a',
                    name: 'download',
                    docSpecific: false},
                {
                    id:"73",
                    label: intl_msg[4566],
                    selected: 'n/a',
                    name: 'financial',
                    docSpecific: false},
                {
                    id:"74",
                    label: intl_msg[4567],
                    selected: 'n/a',
                    name: 'legal',
                    docSpecific: false},
                {
                    id:"75",
                    label: intl_msg[4568],
                    selected: 'n/a',
                    name: 'businessCase',
                    docSpecific: false},

            ];
            if($rootScope.hasMetadataAutoExtractPermission){
                arr.push({
                    id:"12410",
                    label: intl_msg[28990],
                    selected: 'n/a',
                    name: 'metadataAutoExtract',
                    disableNo:true,
                    docSpecific: false})
            };
            if($rootScope.hasMdClausePorting){
                arr.push({
                    id:"13009",
                    label: intl_msg[32460],
                    selected: 'n/a',
                    name: 'mdClausePorting',
                    disableNo:true,
                    docSpecific: false})
            };
            if($rootScope.hasObligationPorting){
                arr.push({
                    id:"13010",
                    label: intl_msg[32461],
                    selected: 'n/a',
                    name: 'obligationPorting',
                    disableNo:true,
                    docSpecific: false})
            };
            return arr;
        }
        this.validIDFieldcheck = function ({ id, type }) {
            const validations = {
                'documentId': { allowedLength: 128, allowedSpecialChars: [".", "-", "@", "_"] },
                'externalId': { allowedLength: 20, allowedSpecialChars: [ '_', '-', '@'] }
            }
            return id.length <= validations[type].allowedLength && (id == "" || SirionUtils.alphaNumericCheck(id, validations[type].allowedSpecialChars));
        };
        /**** getTreeJson : function to be called on click of edit in document tree ****/
        this.getTreeJson = function (returnPromise = false) {
            self.replacedFileObj = [];
            if (self.uploadDocLayout == '') {
                if(returnPromise){
                    startLoader();
                }
                var mUrl = null;
                const wf_id = $rootScope?.createForWorkflowId || sessionStorage.getItem("wf_id");
                if(sessionStorage.getItem("wf_id")){
                    sessionStorage.removeItem("wf_id")
                }
                if((self.pageType == 'show' || self.pageType == 'edit') ){
                    if(!SirionUtils.isEmpty(self.selectedContractId)) {
                        mUrl = addtStamp('/contracts/edit/' + self.selectedContractId + '?version=2.0&documentMetaDataCall=yes');
                    }
                }else{
                    mUrl = addtStamp(self.metadataUrl+ '?version=2.0&documentMetaDataCall=yes');
                }
                if(!mUrl){
                    return;
                }
                wf_id && (mUrl += `&workflowId=${wf_id}`);
                var globalCreate = false;
                if(mUrl.indexOf("v1") != -1){
                    globalCreate = true;
                }
                const httpPromise = $http({
                    method: globalCreate ? 'POST':'GET',
                    url: mUrl,
                    data: globalCreate? self.docUploadPostBody : ''
                }).then(function (res) {
                    if(returnPromise){
                        stopLoader();
                    }
                    self.uploadDocLayout = res.data;
                    if (self.uploadDocLayout && self.uploadDocLayout.body) {
                        var propIdx = _.findIndex(self.uploadDocLayout.body.layoutInfo.layoutComponent.fields[0].fields, function (obj) {
                            return obj.properties && obj.properties.url == '/file/upload/contractDocument';
                        })
                        if (propIdx != -1) {
                            const fieldData = self.uploadDocLayout.body.layoutInfo.layoutComponent.fields[0].fields[propIdx].fields;
                            const docIDField = fieldData.find(doc => doc.type == 'text' && doc.name == 'documentId');
                            if (docIDField) {
                                fieldData.push({
                                  ...JSON.parse(JSON.stringify(docIDField)),
                                  name: 'externalId',
                                  id: 99999,
                                  label: 'External ID'
                                });
                              }
                            self.uploadDocProp = fieldData;
                        }
                    }

                    self.uploadDocPropCopy = Object.assign(self.uploadDocProp);
                    self.uploadDocPropName = _.filter(self.uploadDocProp, function (ob) {
                        return ob.type == 'checkbox' || ob.type == 'number' || ob.type == 'text';
                    }).map(function (o) {
                        return o.name;
                    });

                    if(self.contractDocuments == undefined){
                        self.contractDocuments = [];
                    }
                    if( self.contractDocumentsCopy == undefined && self.contractDocuments == undefined ){
                        self.contractDocumentsCopy = [];
                    }
                    else if( self.contractDocumentsCopy == undefined ){
                        self.contractDocumentsCopy = JSON.parse(JSON.stringify(self.contractDocuments));
                    }
                    
                    return res;
                });
                
                if (returnPromise) {
                    return httpPromise;
                }
            }
            return returnPromise ? Promise.resolve() : undefined;
        };
        /***********************************************************************************************************************/

        /****** triggerFileUpload : function to trigger the click of document upload input ******/
        this.triggerFileUpload = function (e) {
            angular.element('#jx-uploadContractDoc').attr('multiple', 'multiple');
            angular.element('#jx-uploadContractDoc').removeData('replacefile');
            if (angular.element(e?.currentTarget).data('targetarea') == 'topbar') {
                angular.element('#jx-uploadContractDoc').data('parentcid', angular.element('.jx-selectedDoc').data('cid'));
            } else if (angular.element(e?.currentTarget).data('targetarea') == 'withinelem') {
                angular.element('#jx-uploadContractDoc').data('parentcid', angular.element(e.currentTarget).closest('.jx-childElm').data('cid'));
            } else {
                angular.element('#jx-uploadContractDoc').removeData('parentcid');
            }

            angular.element('#jx-uploadContractDoc').click();
        };
        /***********************************************************************************************************************/

        /***** appendNewFile : function to append the uploaded file or link to the document tree ******/
        this.appendNewFileToTree = function(obj,isLink){
            var parentElm = angular.element('.jx-rootElm').find('.child-doc-list').length ? angular.element('.jx-rootElm').find('.child-doc-list:first') : angular.element('<ul/>', {
                'class': 'child-doc-list'
            }).appendTo(angular.element('.jx-rootElm'));
            var selectedElm = angular.element('.jx-rootElm');
            if (obj.hasOwnProperty('parentId')) {
                parentElm = angular.element('#jx-treeDoc-' + obj.parentId).find('.child-doc-list').length ? angular.element('#jx-treeDoc-' + obj.parentId).find('.child-doc-list:first') : angular.element('<ul/>', {
                    'class': 'child-doc-list'
                }).appendTo(angular.element('#jx-treeDoc-' + obj.parentId));
                selectedElm = angular.element('#jx-treeDoc-' + obj.parentId);
            }
            parentElm.prepend(docTreerenderer(obj).addClass('no-child'));
            if (!parentElm.closest('li').find('.icon-down-arrow').length) {
                parentElm.closest('li').prepend('<i class="icon-down-arrow"></i>');
                selectedElm.closest('ul').addClass('has-child');
                parentElm.closest('li').removeClass('no-child');
            }
            if(isLink){
                self.contractDocuments.unshift(obj);
            }
        }
        this.appendNewFile = function (obj, $scope) {
           /* var parentElm = angular.element('.jx-rootElm').find('.child-doc-list').length ? angular.element('.jx-rootElm').find('.child-doc-list:first') : angular.element('<ul/>', {
                'class': 'child-doc-list'
            }).appendTo(angular.element('.jx-rootElm'));
            var selectedElm = angular.element('.jx-rootElm');
            if (obj.hasOwnProperty('parentId')) {
                parentElm = angular.element('#jx-treeDoc-' + obj.parentId).find('.child-doc-list').length ? angular.element('#jx-treeDoc-' + obj.parentId).find('.child-doc-list:first') : angular.element('<ul/>', {
                    'class': 'child-doc-list'
                }).appendTo(angular.element('#jx-treeDoc-' + obj.parentId));
                selectedElm = angular.element('#jx-treeDoc-' + obj.parentId);
            }*/

            var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
            if(preselectionExists){
                obj["businessCase"] = true;
            }
            obj["displayName"] = unescapeHtml(obj["name"]?.replace(/&amp;/g, "&"));
            //var elmToBeappended = docTreerenderer(obj);
            /*parentElm.prepend(docTreerenderer(obj).addClass('no-child'));
            if (!parentElm.closest('li').find('.icon-down-arrow').length) {
                parentElm.closest('li').prepend('<i class="icon-down-arrow"></i>');
                selectedElm.closest('ul').addClass('has-child');
                parentElm.closest('li').removeClass('no-child');
            }*/
            if (!self.contractDocuments) self.contractDocuments = [];
            self.contractDocuments.unshift(obj);

            self.lastUploadScope = $scope;
            self.syncContractDocumentsToReact(self.contractDocuments);

            /*$timeout(function () {
                $compile(parentElm.find('#jx-treeDoc-' + obj.filekey))(parentElm.scope());
            }, 0);*/
           /* angular.element('.document-list ul:first').animate({
                scrollTop: angular.element("#jx-treeDoc-"+obj.filekey).offset().top
            }, 1000);*/

            self.newlyAppendFileList.push(obj);
        };
        /***********************************************************************************************************************/

        /****** checkForDuplicateFile : function to check the existence of duplicate file *******/
        this.checkForDuplicateFile = function (fileObj) {
            var fIndex = _.findIndex(self.contractDocuments, function (o) {
                return o.name + '.' + o.extension == fileObj.name && o.fileAction != '3';
            });
            return fIndex > -1;
        };
        /********************************************************************************************************/

        /******* addanotherlink : function to add another link, to be called on click of add another link button in upload link dropdown ******/
        this.addanotherlink = function () {
            this.uploadLink.push({
                'linkName': '',
                'link': ''
            });
        };
        /************************************************************************************************************************/

        /***** removeLink : function to remove the link **************************/
        this.removeLink = function (idx) {
            _.pullAt(this.uploadLink, idx);
        };
        /************************************************************************************************************************/

        this.checkLinkWithError = function (linksArr) {
            let linkswithError = 0
            for (var i = 0; i < linksArr.length; i++) {
                /*if (linksArr[i].name.trim() !== '' && (_.filter(self.uploadLink, function (o) {
                        return o.linkName == linksArr[i].name.trim();
                    }).length == 1 &&  _.filter(self.contractDocuments, function (o) {
                        return o.name == linksArr[i].name.trim() && linksArr[i].name.trim() != '';
                    }).length == 0)&& linksArr[i].thirdPartyUrl != '' && regexForURL.test(linksArr[i].thirdPartyUrl)) {
                    self.appendNewFileToTree(linksArr[i],true);
                    _.pullAt(self.uploadLink, Math.abs(linksArr.length - self.uploadLink.length - i));
                } else {*/

                    if (linksArr[i].name.trim() == '') {
                        linkswithError++;
                    }
                    if (_.filter(self.uploadLink, function (o) {
                            return o.linkName == linksArr[i].name.trim() && linksArr[i].name.trim() != '';
                        }).length > 1 || _.filter(self.contractDocuments, function (o) {
                            return o.fileAction != '3' && o.name+ '.' + o.extension == linksArr[i].name.trim()+'.' + linksArr[i].extension && linksArr[i].name.trim() != '';
                        }).length > 0) {
                        linkswithError++;
                    }
                    if (!regexForURL.test(linksArr[i].thirdPartyUrl)) {
                        linkswithError++;
                    }
                //}
            }

            return linkswithError;
        } 

        /************ addLinksToTree : function to add all the links to document tree ******************/
        this.addLinksToTree = function () {
            var linksArr = self.uploadLink.map(function (o) {
                var tObj = {};
                tObj.name = o.linkName;
                tObj.filekey = randomString(16);
                tObj.fileAction = '1';
                tObj.thirdPartyUrl = o.link;
                tObj.extension = 'link';
                return tObj;

            });
            var linkswithError = self.checkLinkWithError(linksArr);
            
            if (linkswithError == 0) {
                for (var i = 0; i < linksArr.length; i++) {
                    /*if (linksArr[i].name.trim() !== '' && (_.filter(self.uploadLink, function (o) {
                            return o.linkName == linksArr[i].name.trim();
                        }).length == 1 &&  _.filter(self.contractDocuments, function (o) {
                            return o.name == linksArr[i].name.trim() && linksArr[i].name.trim() != '';
                        }).length == 0)&& linksArr[i].thirdPartyUrl != '' && regexForURL.test(linksArr[i].thirdPartyUrl)) {
                        self.appendNewFileToTree(linksArr[i],true);
                        _.pullAt(self.uploadLink, Math.abs(linksArr.length - self.uploadLink.length - i));
                    }*/
                    self.appendNewFileToTree(linksArr[i],true);
                    self.linkFlag = false;
                    }
                    self.uploadLink = [];
                    self.uploadLink.push({
                        'linkName': '',
                        'link': ''
                    });
                    angular.element('.listPreference').click();

                    if (self.uploadScope) {
                        self.uploadAllFiles(self.uploadScope.data, self.uploadScope);
                    }
                } else {
                    self.linkFlag = true;
                }
            };
            /***********************************************************************************************************************/

            this.uploadFileLink = function(doc){
                self.uploadLink = doc.files || [];
                self.addLinksToTree();
            }

        /******** checkForValidLink : function to check the validity of link, to be called on blur of link input ******/
        this.checkForValidLink = function (e, val) {
            if (regexForURL && !regexForURL.test(val)) {
                angular.element(e.target).closest('.row').find('.errorMessage').html(intl_msg[6496]);

            } else {
                angular.element(e.target).closest('.row').find('.errorMessage').html('');
            }
        };
        /*************************************************************************************************************/

        /******* checkForDuplicateLink : function to check for the existence of duplicate link name *******/
        this.checkForDuplicateLink = function (e, val) {
            self.linkFlag = (val.trim() == '') || (_.filter(self.uploadLink, function (o) {
                return (o.linkName == val.trim());
            }).length > 1) || (!regexForURL.test(val));
        };
        /*************************************************************************************************************/

        /****** toggleFileaction : function to be called on change of checkbox to show applicable actions *****/
        this.toggleFileaction = function (e) {
            var currentDocTile = angular.element(e.target).closest('.jx-childElm');
            var cid = currentDocTile.data("cid");
            currentDocTile.toggleClass('jx-selectedDoc');
            var currentTileArr = _.filter(self.contractDocuments, function (o) {
                if (o.id) {
                    return o.id == parseInt(cid);
                }
                else {
                    return o;
                }
            });
            if (currentDocTile.hasClass('jx-selectedDoc')) {
                currentDocTile.find('.jx-doc-checkbox').prop('checked', true);
                currentDocTile.find('.jx-childElm').addClass('jx-selectedDoc');
                var selectedArr  =  _.map(angular.element('.jx-selectedDoc:not(".jx-filesToBeDeleted")'), function (o) {
                    return angular.element(o).data('cid');
                });
                var selectedElm = _.intersectionWith(self.contractDocuments, selectedArr, function (aobj, oobj) {
                    return aobj.id == oobj || aobj.filekey == oobj;
                });
                this.showfileaction = true;
                this.selectedTileArray = selectedElm;

            } else {
                currentDocTile.find('.jx-doc-checkbox').prop('checked', false);
                currentDocTile.find('.jx-childElm').removeClass('jx-selectedDoc');
                var index = this.selectedTileArray.indexOf(currentTileArr[0]);
                var selectedArr = _.map(angular.element('.jx-selectedDoc'), function (o) {
                    return angular.element(o).data('cid');
                });
                this.selectedTileArray = _.intersectionWith(self.selectedTileArray, selectedArr, function (aobj, oobj) {
                    return aobj.id == oobj || aobj.filekey == oobj;
                });
            }
            this.deleteItemOption = true;
            updateFileOptions();

        };

        /***************************************************************************************************************/
        this.postObjOfContractDocuments = function(isCreate){
            if(!self.contractDocuments || self.contractDocuments.length==0){
                var postFileObj = [];
            }else {
                var postFileObj = self.contractDocuments.map(function (fobj) {

                    if (fobj.hasOwnProperty('fileAction') && fobj.fileAction == '3' && fobj.hasOwnProperty('filekey')) {
                        angular.noop();
                    } else {
                        var tempf = {};
                        for (var i = 0; i < self.uploadDocPropName.length; i++) {
                            if (fobj.hasOwnProperty(self.uploadDocPropName[i])) {
                                tempf[self.uploadDocPropName[i]] = fobj[self.uploadDocPropName[i]];
                                if (['startPageNumber', 'numberOfPagesToExclude'].indexOf(self.uploadDocPropName[i]) > -1 && (tempf[self.uploadDocPropName[i]] == false || fobj['customNumbering'] == false)) {
                                    tempf[self.uploadDocPropName[i]] = null;
                                }
                            } else {
                                if (['startPageNumber', 'numberOfPagesToExclude','documentId','externalId'].indexOf(self.uploadDocPropName[i]) > -1) {
                                    tempf[self.uploadDocPropName[i]] = null;
                                } else {
                                    tempf[self.uploadDocPropName[i]] = false;
                                }

                            }
                        }
                        tempf['name'] = fobj.name;
                        tempf['extension'] = fobj.extension;
                        tempf['parentId'] = fobj.parentId;
                        if (fobj.hasOwnProperty('fileAction') && fobj.hasOwnProperty('fileAction') == '3' && fobj.hasOwnProperty('filekey')) {
                            angular.noop();
                        }
                        if (fobj.hasOwnProperty('fileAction')) {
                            if (isCreate) {
                                tempf['CDAction'] = fobj.fileAction.toString();
                            } else {
                                tempf['cdAction'] = fobj.fileAction;
                            }


                        }
                        if (fobj.hasOwnProperty('id')) {
                            tempf['id'] = fobj.id;
                        }
                        if (fobj.hasOwnProperty('filekey')) {
                            tempf['key'] = fobj.filekey;
                        }
                        if (tempf['extension'] == 'link') {
                            tempf['thirdPartyUrl'] = fobj.thirdPartyUrl;
                            tempf['totalPages'] = null;
                            tempf['externalId'] = null;
                        }
                        if(!fobj.metadataAutoExtract){
                            tempf.mdClausePorting = false;
                            tempf.obligationPorting = false;
                        }


                        return tempf;
                    }
                });
            }
            _.remove(postFileObj, function (n) {
                return n == undefined;
            });
            if($(".importFromCdr [my-table]").length >1){
                var tableSc = $(".importFromCdr [my-table]").eq(1).scope();
                tableSc.selectedCheckBoxes.forEach(function(item,index){
                    item && postFileObj.push({"auditLogDocFileId":item});
                })
            }
            return postFileObj;
        }
        this.customNumberingCheckValidation = function (scope) {
            if(this.contractDocuments || scope.pageType == "clone" || scope.pageType == "globalCreate"){
                for (var y in this.contractDocuments) {
                    if (this.contractDocuments[y].customNumbering == true && this.contractDocuments[y].fileAction != "3") {
                        var totalPageNumber = this.contractDocuments[y].totalPages;
                        var startPageNumber = this.contractDocuments[y].startPageNumber;
                        var numberOfPagesToExclude = this.contractDocuments[y].numberOfPagesToExclude;
                        if(((startPageNumber || numberOfPagesToExclude) == '') || ((startPageNumber || numberOfPagesToExclude) < 0) || ((startPageNumber || numberOfPagesToExclude) == 0) || ((startPageNumber || numberOfPagesToExclude) > 10000) || numberOfPagesToExclude > parseInt(totalPageNumber)){
                            return true;
                        }
                    }
                }
            }
            return false;
        }
        /** uploadAllFiles : function to upload all the files to server on click of done  **/
        this.uploadAllFiles = function (dt, scope) {
            if(scope.noOfFilesUploaded > 0){
                Toaster.create( intl_msg[6497] || 'File is being Uploaded! Please wait...',{iconClass:"icon-Information_filled"});
                return;
            }

            var invalidDocumentId = _.filter(self.contractDocuments, function (ob) {
                return (ob.documentId && !SirionUtils.alphaNumericCheck(ob.documentId, [".", "-", "@", "_"]));
            });
            var filesWithCNOn = _.filter(self.contractDocuments, function (ob) {
                return (ob.fileAction != '3' && ob.customNumbering && (!ob.startPageNumber || !ob.numberOfPagesToExclude)) ;
            });

            if(this.customNumberingCheckValidation(scope)){
                SirionUtils.openSirionDialogs({popupType: 'alert', str: "Input for document start page number / initial pages to exclude is incorrect", heading: "ERROR",yesCbFn: cancelString,yesName: intl_msg[24184]});
                return;
            }
            if(filesWithCNOn.length){
                self.openFilePropertiesModal(false,filesWithCNOn);
            } else if (invalidDocumentId.length) {
                SirionUtils.openSirionDialogs({popupType: 'alert', str: "Input for documentId is incorrect - should be alphanumeric text", heading: "ERROR",yesCbFn: cancelString,yesName: intl_msg[24184]});
                self.openFilePropertiesModal(false, invalidDocumentId);
            } else {
                startLoader();
                var postObj = {
                    'contractDocuments': self.postObjOfContractDocuments(),
                    'contractId': self.selectedContractId,
                    'relationId': self.supplierId,
                    'contractDocumentUpdateCall':"yes",
                    'multiSupplierIds': self.multiSupplierIds
                };
                if(dt && (_.has(dt,"contractProjects.values.id")) ){
                    postObj.contractDocuments = postObj.contractDocuments.map(function(doc){
                        doc.projects = [dt.contractProjects.values.id];
                        return doc;
                    })
                }
                $http({
                    dataType: "json",
                    data: postObj,
                    contentType: "application/json;charset=UTF-8",
                    method: 'POST',
                    url: appName + "/api/v1/contracts/document/update"
                }).then(function (res) {
                    if (res.data.status == "success") {
                        stopLoader();
                        angular.element('div#alertdialog').remove();
                        let cacheData = JSON.parse(localStorage.getItem('docTreeCache') || '[]');
                        let cacheItemIndex = cacheData.findIndex(item => Object.keys(item)[0] == self.supplierId);
                        if (cacheItemIndex !== -1) {
                            cacheData.splice(cacheItemIndex, 1);
                            try {
                                localStorage.setItem('docTreeCache', JSON.stringify(cacheData));
                            } catch (e) {
                                localStorage.removeItem('docTreeCache');
                                window.systemWarning("Error saving in localStorage:", e)
                            }
                        }
                    Toaster.create(intl_msg[7062],{},function () {
                        self.contractDocuments = res.data.contractDocuments.contractDocuments;/******************* Reset contractDocumentsCopy  ************************/
                        if(!SirionUtils.isEmpty(self.replacedFileObj)){
                            self.replacedFileObj.forEach(replacedItem => {
                                const contractItem = self.contractDocuments.find(item => item.id == replacedItem.id);
                                if (contractItem.name != replacedItem.name) {
                                    contractItem.name = replacedItem.name;
                                }
                            });
                        }
                        self.contractDocumentsCopy = JSON.parse(JSON.stringify(self.contractDocuments));
                        var parentElm = angular.element('.jx-rootElm');
                        angular.element('.jx-rootElm').find('.child-doc-list').remove();
                        treeeJson = {};
                        self.showDoctreeTemplate = false;
                        self.updateDocListInReact(scope,self.contractDocuments);
                        window.sarc.channelBroadcast("miraDocRepo",{
                            actionType:'updateDocument'
                        },'miraDocRepoSubscription');
                        const updatedContractObj = res.config.data;
                        updatedContractObj.contractDocuments = res.data.contractDocuments.contractDocuments;
                        window.updatedContractObj = updatedContractObj;
                        $timeout(function () {
                            $rootScope.docTreeScpCompiled = true;
                            preserveFltrMap.filterDataJson = angular.copy(window.filterDataJson);
                            preserveFltrMap.filterDefaultDataJson = angular.copy(window.filterDefaultDataJson);
                            $compile(angular.element('.jx-docTreeDiv').find('tree-Directive'))(angular.element('.jx-docTreeDiv').scope());
                        }, 0);
                        self.selectedTileArray = [];
                        self.showfileaction = false;
                        if (scope.showEditButton) {
                            scope.showEditButton.enabled = true;
                        }

                    })
                    } else if(res.data.status == "applicationError" || res.data.errorMessages != null){
                        stopLoader();
                        var str='';
                        if(res.data.errorMessage && typeof response.data.errorMessage =='string'){
                            Toaster.create(response.data.errorMessage,{iconClass:"icon-Information_filled"});
                        }else if(res.data.errorMessages && SirionUtils.isArray(res.data.errorMessages)) {
                            if(res.data.errorMessages.length > 1){
                                for (var i =0; i < res.data.errorMessages.length; i++) {
                                    str += res.data.errorMessages[i].errorMessage;
                                    str += "</br>";
                                }
                            }else{
                                str =res.data.errorMessages[0].errorMessage;
                            }
                            Toaster.create(str,{iconClass:"icon-Information_filled"});
                        }
                    }
                });
            }
        };
        /*********************************************************************************************************************/

        /******* deleteContractFiles : function to delete contract files **********************************/
        this.deleteContractFiles = function (field) {
            var cId = [];
            if (field.targetArea == 'topbar') {
                var selectedDocToBeDeleted = angular.element('.jx-selectedDoc');
                cId = _.map(selectedDocToBeDeleted, function (o) {
                    return angular.element(o).data('cid');
                });
                cId = _.union(cId, _.map(selectedDocToBeDeleted.find('.jx-childElm'), function (o) {
                    return angular.element(o).data('cid');
                }));
                selectedDocToBeDeleted.addClass('jx-filesToBeDeleted');
                selectedDocToBeDeleted.find('.jx-childElm').addClass('jx-filesToBeDeleted');
                selectedDocToBeDeleted.hide();
                for(var i =0;i<selectedDocToBeDeleted.length;i++){
                    if(!angular.element(selectedDocToBeDeleted[i]).closest('ul').closest('li').find('.jx-childElm:not(".jx-filesToBeDeleted")').length){
                        angular.element(selectedDocToBeDeleted[i]).closest('ul').closest('li').find('>.icon-down-arrow').remove();
                        angular.element(selectedDocToBeDeleted[i]).closest('ul').closest('li').addClass('no-child');
                    }
                }

            } else if (field.targetArea == 'contractMenu') {
                cId = _.map(self.contractDocuments, function (contract) {
                    return contract.id;
                });
            } else {
                cId.push(field.elmToBeDeleted);
                cId = _.union(cId, _.map(angular.element('#jx-treeDoc-' + field.elmToBeDeleted).find('.jx-childElm'), function (o) {
                    return angular.element(o).data('cid');
                }));
                angular.element('#jx-treeDoc-' + field.elmToBeDeleted).find('.jx-childElm').addClass('jx-filesToBeDeleted');
                angular.element('#jx-treeDoc-' + cId[0]).addClass('jx-filesToBeDeleted');
                angular.element('#jx-treeDoc-' + cId[0]).hide();
                if(!angular.element('#jx-treeDoc-' + cId[0]).closest('ul').closest('li').find('.jx-childElm:not(".jx-filesToBeDeleted")').length){
                    angular.element('#jx-treeDoc-' + cId[0]).closest('ul').closest('li').find('>.icon-down-arrow').remove();
                    angular.element('#jx-treeDoc-' + cId[0]).closest('ul').closest('li').addClass('no-child');
                }

        }
        var tObj = _.intersectionWith(self.contractDocuments, cId, function (aobj, oobj) {
            return aobj.id == oobj || aobj.filekey == oobj;
        });
        for (var i = 0; i < tObj.length; i++) {
            tObj[i]['fileAction'] = '3';
}
        self.contractDocuments = _.filter(self.contractDocuments, (doc) => {
            if(doc.filekey && doc.filekey == field.elmToBeDeleted) return false;
            return true;
        })

        /**********************  Update self.contractDocumentsCopy  ***********
        var _tCopyObj = _.intersectionWith(self.contractDocumentsCopy, cId, function (aobj, oobj) {
            return aobj.id == oobj || aobj.filekey == oobj;
        });
             for (var i = 0; i < _tCopyObj.length; i++) {
            _tCopyObj[i]['fileAction'] = '3';
        }
             /!**********************  Update self.contractDocuments  ************!/
             for(var i = 0; i < cId.length; i++){
            _.remove(self.contractDocuments, x => (x.id||x.filekey) === cId[i]);
        }*/
       
            if (self.uploadScope) {
                self.uploadAllFiles(self.uploadScope.data, self.uploadScope);
            }
            
            updateFileOptions();
        };
        /*******************************************************************************************************/

        /****** downloadContractDoc : function to be called on click of download *******/
        this.downloadContractDoc = function (e, cid) {
            var cid = cid;
            if (angular.element(e.currentTarget).data('targetarea') == 'topbar') {
                cid = angular.element('.jx-selectedDoc').data('cid');
            }
            angular.element('#jx-download-doc').attr('href', appName + "/download/contractdocument/" + cid);
            angular.element('#jx-download-doc')[0].click();

        };

        this.downloadHoverContractDocOptn = function (rowArgs) {
            var jsonObj = JSON.parse(unescape(rowArgs));
            var retval = false;
            if (this.selectedTileArray.length == 0) {
                retval = jsonObj.download;
            }
            else if (this.selectedTileArray.length == 1) {
                if (jsonObj.id == undefined) {
                    retval = false;
                }
                else {
                    if (this.selectedTileArray[0].id == jsonObj.id) {
                        retval = this.selectedTileArray[0]["download"];
                    }
                }
            }
            else {
                if (jsonObj.id == undefined) {
                    retval = false;
                }
                for (var i = 0; i < self.selectedTileArray.length; i++) {
                    if (self.selectedTileArray[i].id == jsonObj.id) {
                        retval = this.selectedTileArray[i]["download"];
                    }
                }
            }

            return retval;
        };

        /*********************************************************************************************************/

        /**** replaceFile : function to be called on click of replace *********************/
        this.replaceFile = function (e) {
            if (angular.element(e.currentTarget).data('targetarea') == 'topbar') {
                self.fileToBeReplaced = angular.element('.jx-selectedDoc').data('cid');
            } else {
                self.fileToBeReplaced = angular.element(e.currentTarget).closest('.jx-childElm').data('cid');
            }
            var selContract = _.find(self.contractDocuments, function (o) {
                return (o.id == self.fileToBeReplaced || o.filekey == self.fileToBeReplaced);
            });
            if (selContract.extension != 'link') {
                angular.element('#jx-uploadContractDoc').removeAttr('multiple');
                angular.element('#jx-uploadContractDoc').removeData('parentcid');
                angular.element('#jx-uploadContractDoc').data('replacefile', true);
                angular.element('#jx-uploadContractDoc').click();
            } else {
                self.replaceLink(selContract, e)
            }


        };
        this.makeFileRenamable = function(e){
            var cId;
            if (angular.element(e.currentTarget).data('targetarea') == 'topbar') {
                cId = angular.element('.jx-selectedDoc').data('cid');
            } else {
                cId = angular.element(e.currentTarget).closest('.jx-childElm').data('cid');
            }
            $timeout(function(){angular.element('#jx-treeDoc-'+cId).find('em').first().dblclick();},0);
        }
        /*************************************************************************************************/
        this.replaceLink = function (linkObj, e) {
            var innerHtml = $("<div>").append($(htmlForDocumentReplace).clone());
            var innerContainer = innerHtml.find(".tabs-inner-sec-content");
            innerHtml.find("input[name='thirdPartyUrl']").show();
            innerHtml.find("input[name='thirdPartyUrl']").val(linkObj.thirdPartyUrl);
            innerContainer.find("input[name='name']").val(linkObj.name);
            innerContainer.find("input[name='name']").attr("maxLength", 256);
            innerHtml.find("#generalTab").append($('<div class = "submit"><input type = "button" class = "reset update" value = "Update"/></div>'));
            innerHtml.find(".update").click(function () {
                if (innerHtml.find("input[name='name']").val().trim() == "") {
                    Toaster.create(intl_msg[6426],{iconClass:"icon-Information_filled"});
                    innerHtml.find("input[name='name']").addClass("errorClass");
                    return false;
                } else {
                    linkObj.name = innerHtml.find("input[name='name']").val().trim();
                }

                linkObj.thirdPartyUrl = innerHtml.find("input[name='thirdPartyUrl']").val();
                innerHtml.find("input[name='thirdPartyUrl']").addClass("removeClass");
                if (!regexForURL.test(linkObj.thirdPartyUrl)) {
                    Toaster.create(intl_msg[6427],{iconClass:"icon-Information_filled"});
                    innerHtml.find("input[name='thirdPartyUrl']").addClass("errorClass");
                    return false;
                }

            if (linkObj.hasOwnProperty('id')) {
                var objectToPost = {
                    body: {
                        data: {
                            "id": {
                                "name": "id",
                                "values": linkObj.id
                            },
                            "CDAction": {
                                "name": "CDAction",
                                "values": "4"
                            },
                            "name": {
                                "name": "name",
                                "values": linkObj.name
                            },
                            "extension": {
                                "name": "extension",
                                "values": (linkObj.extension)
                            },
                            "thirdPartyUrl": {
                                "name": "thirdPartyUrl",
                                "values": linkObj.thirdPartyUrl
                            }
                        }
                    }
                };
                renameReplaceAjaxCall(objectToPost).then(function (res) {
                    if (_.has(res, 'data.header.response') && res.data.header.response.status == 'success') {
                        $("#uploadedFileEdit").dialog("close");
                        angular.element('#jx-treeDoc-' + linkObj.id).find('em:first').text(linkObj.name).attr('title',linkObj.name).closest('small').find('i').attr('class', 'icon-' + linkObj.extension.toLowerCase());
}

                    if (_.has(res, 'data.header.response') && res.data.header.response.errorMessage) {
                        Toaster.create(res.data.header.response.errorMessage,{iconClass:"icon-Information_filled"});
                    }

                    });

                } else {
                    angular.element('#jx-treeDoc-' + linkObj.filekey).find('em:first').text(linkObj.name).attr('title',linkObj.name).closest('small').find('i').attr('class', 'icon-' + linkObj.extension.toLowerCase());
                    $("#uploadedFileEdit").dialog("close");
                }
            });

            $("#uploadedFileEdit").html(innerHtml);
            loadTabs("#uploadTabs");
            $("#uploadedFileEdit").dialog('option', 'title', 'Replace');
            $("#uploadedFileEdit").dialog("open");

        };

        /****** renameFile : function to  be called on click of rename *********/
        this.renameFile = function (e) {
            var cid = $(e.currentTarget).closest('.jx-childElm').data('cid');
            var changedFileName = SirionUtils.getPurifiedValue(angular.element(e.currentTarget).text().trim());
            var selContract = _.find(self.contractDocuments, function (o) {
                return (o.id == cid || o.filekey == cid);
            });
            if(SirionUtils.isEmpty(changedFileName)){
                Toaster.create(intl_msg[6809].replace('(%s)',""),{iconClass:"icon-Information_filled"});
                var _id = selContract.id == null ? selContract.filekey  : selContract.id ;
                angular.element('#jx-treeDoc-' + _id).find('em:first').text(selContract.name).attr('title',selContract.name);
                angular.element(e.currentTarget).attr('title',selContract.name);
                angular.element(e.currentTarget).prop("contenteditable", false);
                angular.element(e.currentTarget).closest('.list-hover').removeClass('editable-content');
                angular.element(e.currentTarget).closest('.jx-childElm').removeClass('editable-content-li');
                return false;
            }

        var selectedContractId = selContract.id!=null?selContract.id:selContract.filekey;var objectToPost = {
            body: {
                data: {
                    "id": {
                        "name": "id",
                        "values": cid
                    },
                    "CDAction": {
                        "name": "CDAction",
                        "values": "4"
                    },
                    "name": {
                        "name": "name",
                        "values": changedFileName
                    },
                    "extension": {
                        "name": "extension",
                        "values": (selContract.extension)
                    },
                    "thirdPartyUrl": {
                        "name": "thirdPartyUrl",
                        "values": selContract.thirdPartyUrl
                    },
                    "externalId":{
                        "name":"externalId",
                        "values":selContract.externalId
                    }
                }
            }
        };

        if (selContract.name != changedFileName) {
            if (selContract.hasOwnProperty('id')) {
                renameReplaceAjaxCall(objectToPost).then(function (res) {
                    if (_.has(res, 'data.header.response') && res.data.header.response.status == 'success') {
                        selContract.name = changedFileName;
                        /************** updateContractDocumentCopy *******************/
                            var updatedObj = SirionUtils.findInArray(self.contractDocumentsCopy,selectedContractId);
                            updatedObj.name = changedFileName;angular.element(e.currentTarget).attr('title',selContract.name);
                        const existingItem = self.replacedFileObj.find(item => item.id == selContract.id);

                        if (!existingItem || existingItem.name != selContract.name) {
                            self.replacedFileObj.push(selContract);
                        }
                    }
                    if (_.has(res, 'data.header.response') && res.data.header.response.errorMessage) {
                        Toaster.create(res.data.header.response.errorMessage,{iconClass:"icon-Information_filled"});
                    }

                });
            } else if (selContract.hasOwnProperty('filekey')) {
                selContract.name = changedFileName;
                /************** updateContractDocumentCopy *******************/
                    var updatedObj = SirionUtils.findInArray(self.contractDocumentsCopy,selectedContractId);
                    updatedObj.name = changedFileName;angular.element(e.currentTarget).attr('title',selContract.name);
            }
        }

            if (_.has(selContract, 'documentId') && _.get(selContract, 'documentId')) {
                angular.element(e.currentTarget)[0].textContent += ` (${selContract.documentId})`;
            }
            angular.element(e.currentTarget).prop("contenteditable", false);
            angular.element(e.currentTarget).closest('.list-hover').removeClass('editable-content');
            angular.element(e.currentTarget).closest('.jx-childElm').removeClass('editable-content-li');
        };
        /*******************************************************************************************************************/

    /**** replaceExistingFile : function to be called on successful upload of new file ***/
    this.replaceExistingFile = function (fobj) {
        var selContract = _.find(self.contractDocuments, function (o) {
            return (o.id == self.fileToBeReplaced);
        });
        var objectToPost = {
            body: {
                data: {
                    "id": {
                        "name": "id",
                        "values": self.fileToBeReplaced
                    },
                    "CDAction": {
                        "name": "CDAction",
                        "values": "4"
                    },
                    "name": {
                        "name": "name",
                        "values": fobj.name
                    },
                    "extension": {
                        "name": "extension",
                        "values": (fobj.extension)
                    },
                    "thirdPartyUrl": {
                        "name": "thirdPartyUrl",
                        "values": fobj.thirdPartyUrl
                    },
                    'key': {
                        "name": "key",
                        "values": fobj.filekey
                    },
                    "externalId":{
                        "name":"externalId",
                        "values":selContract.externalId
                    }
                }
            }
        };
        renameReplaceAjaxCall(objectToPost).then(function (res) {
            if (_.has(res, 'data.header.response') && res.data.header.response.status == 'success') {
                selContract.name = fobj.name;
                selContract.extension = fobj.extension;
                selContract.totalPages = fobj.totalPages;
                angular.element('#jx-treeDoc-' + self.fileToBeReplaced).find('em:first').text(fobj.name).attr('title',fobj.name).closest('small').find('i').attr('class', 'icon-' + fobj.extension.toLowerCase());
/************** updateContractDocumentCopy *******************/
                    var ObjToUpdate = SirionUtils.findInArray(self.contractDocumentsCopy,selContract.id);
                    ObjToUpdate.name = fobj.name;
                    ObjToUpdate.extension = fobj.extension;
                    ObjToUpdate.totalPages = fobj.totalPages;
            }
            if (_.has(res, 'data.header.response') && res.data.header.response.errorMessage) {
                Toaster.create(res.data.header.response.errorMessage,{iconClass:"icon-Information_filled"});
            }

            });
        };
        /*******************************************************************************************************************/

        /***** makeDivEditable : function to make div editable for rename ************/
        this.makeDivEditable = function (e) {
            angular.element(e.currentTarget).prop("contenteditable", true);
            angular.element(e.currentTarget).closest('.list-hover').addClass('editable-content');
            angular.element(e.currentTarget).closest('.jx-childElm').addClass('editable-content-li');
            var doc = document;
            var element = angular.element(e.currentTarget)[0];
            const keys = Object.keys(this.hovered);
            if (keys.length) {
                const key = keys.filter(key => this.hovered[key])[0];
                const doc = self.contractDocuments.find(doc => (doc.filekey || doc.id) == key);
                const { name, documentId } = doc;
                element.textContent = name;
            }
            if (doc.body.createTextRange) {
                var range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                var selection = window.getSelection();
                var range = document.createRange();
                range.selectNodeContents(element);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        };
        /**************************************************************************************************************/

        /***** updateContractDocObj : function to update the settings *******/
        this.updateContractDocObj = function (e,row,_isFromLineHover,rowId,isNewUpload) {
            e.stopPropagation();
            var propCheckedVal = angular.element(e.target).prop('checked');
            var idFieldValue = ["documentId", "externalId"].includes(row.name) && angular.element(e.currentTarget).val();
            if (idFieldValue) idFieldValue = idFieldValue.trim();
            if (row.name == "customNumbering") {
                if (this.selectedTileArray.length <= 1) {
                    self.resetCustomNumberingProps();
                    if(_isFromLineHover){
                        if(this.selectedTileArray.length == 1){
                            if(this.selectedTileArray[0].id == rowId || this.selectedTileArray[0].filekey == rowId )
                            {
                                self.showCustomNumbering  = row.isChecked;
                            }
                        }
                        else{
                            self.showCustomNumbering  = row.isChecked;
                        }
                    }
                    else{
                        self.showCustomNumbering  = row.isChecked;
                    }
                }
                else{
                    self.showCustomNumbering = false;
                }
                if(propCheckedVal){
                    angular.element(e.currentTarget).closest('ul').find('.jx-cnfieldDD').removeClass('ng-hide').show();
                }else{
                    angular.element(e.currentTarget).closest('ul').find('.jx-cnfieldDD').hide();
                }
            }
            else if (row.name == "download") {
                if(isNewUpload){
                    self.downloadContractDocOption = false;
                }
                else{
                    self.downloadContractDocOption = row.isChecked;
                    if (row.isChecked) {
                        if (this.selectedTileArray.length == 1) {
                            self.downloadContractDocOption = true;

                        }
                        else {
                            self.downloadContractDocOption = false;
                        }
                    }
                }

            }
            if(row.name == "metadataAutoExtract"){
               self.disableEnableAEOptions(e, propCheckedVal);
            }
            if (["documentId", "externalId"].includes(row.name)) {
                const validInput = this.validIDFieldcheck({ id: idFieldValue, type: row.name });
                const errorClass = row.name == 'documentId' ? 'docIdErrorInput' : 'extIdErrorInput';
                validInput ? e.currentTarget.classList.remove(errorClass) : e.currentTarget.classList.add(errorClass);
                for (var y in self.contractDocuments) {
                    if ((self.contractDocuments[y].hasOwnProperty('id') && rowId == self.contractDocuments[y].id) || (self.contractDocuments[y].hasOwnProperty('filekey') && rowId == self.contractDocuments[y].filekey)) {
                        self.contractDocuments[y][row.name] = idFieldValue;
                        if (self.contractDocuments[y].hasOwnProperty('id')) {
                            self.contractDocuments[y]['fileAction'] = 2;
                            var updatedObj = SirionUtils.findInArray(self.contractDocumentsCopy, self.contractDocuments[y]['id']);
                            updatedObj['fileAction'] = 2;
                        }
                    }
                }
            }else if(_isFromLineHover){
                for (var y in self.contractDocuments) {
                    if ((self.contractDocuments[y].hasOwnProperty('id') && rowId == self.contractDocuments[y].id) ||(self.contractDocuments[y].hasOwnProperty('filekey') && rowId == self.contractDocuments[y].filekey)) {
                        self.contractDocuments[y][row.name] = propCheckedVal;
                        setStatusOfFileProp(row,self.contractDocuments[y],propCheckedVal);
                        if(self.contractDocuments[y].hasOwnProperty('id')){
                            self.contractDocuments[y]['fileAction'] = 2;
                            var updatedObj = SirionUtils.findInArray(self.contractDocumentsCopy,self.contractDocuments[y]['id']);
                            updatedObj['fileAction'] = 2;
                        }
                    self.setFilePropertiesDropDown(self.contractDocuments[y]);
                    }
                }

                let rowElem = self.filePropList && self.filePropList.find( (prop) =>{return prop.name == row.name});
                if(rowElem){
                    rowElem.isChecked = self.selectedTileArray
                        .filter(doc =>!this.setPropDisabled(row.name, doc.extension))
                        .every(doc => doc[row.name]);
                }
            }
        else{
            for (var x in self.selectedTileArray) {
                for (var y in self.contractDocuments) {
                    if ((self.contractDocuments[y].hasOwnProperty('id') && self.selectedTileArray[x].id == self.contractDocuments[y].id)
                        ||(self.contractDocuments[y].hasOwnProperty('filekey') && self.selectedTileArray[x].filekey == self.contractDocuments[y].filekey)) {

                         //self.contractDocuments[y][row.name] = row.isChecked;
                        if (!(row.name == 'mdClausePorting' || row.name == 'obligationPorting') || !self.selectedTileArray[x].id){
                            self.contractDocuments[y][row.name] = propCheckedVal;
                            setStatusOfFileProp(row,self.contractDocuments[y],propCheckedVal);
                        }

                    }
                    if(self.contractDocuments[y].hasOwnProperty('id')){
                        self.contractDocuments[y]['fileAction'] = 2;
                            var updatedObj = SirionUtils.findInArray(self.contractDocumentsCopy,self.contractDocuments[y]['id']);
                            updatedObj['fileAction'] =2;
                    }
                }
            }
            self.setFilePropertiesDropDown(row);
        }

        };
        this.disableEnableAEOptions = function(eve,propCheckedVal){
            var item = angular.element(eve.currentTarget).closest('ul');
            var table = angular.element(eve.currentTarget).closest('tr');
            if(table.length > 0){
                var td  = table[0].children;
                for(var y = 0 ; y < td.length ; y++){
                    var txt = td[y].children[0].title || td[y].children[0].innerText.slice(0,-1);
                    if(txt === intl_msg[32460] || txt === intl_msg[32461]){
                        if(propCheckedVal){
                            td[y].classList.remove('disabled')
                                if(td[y].children[1]){
                                    td[y].children[1].disabled = false
                                    td[y].style.opacity = 1
                                }else{
                                    td[y].children[0].children[1].firstElementChild.disabled = false
                                    let elem = document.querySelectorAll(`[title= "${txt}"]`)
                                    elem.forEach(function(item){
                                        item.nextElementSibling.disabled = false
                                        item.parentElement.style.opacity = 1
                                    })
                                }
                        }else{
                            td[y].classList.add('disabled')
                            if(td[y].children[1]){
                                td[y].children[1].disabled = true;
                                td[y].style.opacity = 0.5
                            }else{
                                td[y].children[0].children[1].firstElementChild.disabled = true;
                                td[y].style.opacity = 1
                                let elem = document.querySelectorAll(`[title= "${txt}"]`)
                                elem.forEach(function(item){
                                    item.nextElementSibling.disabled = true
                                    item.parentElement.style.opacity = 0.5
                                })
                            }
                        }
                    }
                }
            }else if(item.length >0){
                var li = item[0].children;
                for(var y = 0 ; y < li.length ; y++){
                    if(li[y].childNodes[5]){
                        var txt = li[y].childNodes[5].innerText;
                        if(txt === intl_msg[32460] || txt === intl_msg[32461]){
                            if(propCheckedVal){
                                li[y].childNodes[1].disabled = false;
                                li[y].style.opacity = 1;
                            }else{
                                li[y].childNodes[1].disabled = true;
                                li[y].style.opacity = 0.5;
                            }
                        }
                    }
                }
            }
        };
        this.resetCustomNumberingProps =function(){

            for(var obj in self.customNumberingProps){
                if(self.customNumberingProps[obj] == false && obj!= "disabled"){
                    self.customNumberingProps[obj] = "";
                }
                else if(obj == "totalPages"){
                    continue;
                }
                else{
                    self.customNumberingProps[obj] = false;
                }
            }
        }
        /************************************************************************************************************/

        /******* updateCustomNumberingProps : function to update custom numbering property *******/
        this.updateCustomNumberingProps = function (CustomNumberingObj, str) {

            if (CustomNumberingObj[str] == undefined || CustomNumberingObj[str] == null) {
                angular.element('.' + str).find('.errorMessage').html(intl_msg[8078]||intl_msg[24181]);
                return;
            }
            else if(CustomNumberingObj[str] && CustomNumberingObj[str].trim() == ''){
                angular.element('.' + str).find('.errorMessage').html(intl_msg[8078]||intl_msg[24181]);
                return;
            }
            else if (parseInt(CustomNumberingObj[str]) < 0) {

                CustomNumberingObj[str] = "";
                angular.element('.' + str).find('.errorMessage').html(intl_msg[24182]||'Value can not be negative.');
                return;

            }
            else if(parseInt(CustomNumberingObj[str]) > 100000 ){

                CustomNumberingObj[str] = "";
                angular.element('.' + str).find('.errorMessage').html(intl_msg[24182]||'Value can not be grater than 10000');
                return;
            }

            else {
                angular.element('.' + str).find('.errorMessage').html('');
            }
            for (var x in CustomNumberingObj) {
                for (var y in self.contractDocuments) {
                    if (self.selectedTileArray[0].id == self.contractDocuments[y].id) {
                        self.contractDocuments[y][x] = parseInt(CustomNumberingObj[x]);

                    }
                }
            }
        };

        this.setCustomNumberingProps = function(e,objVal,obj,elId,isFPDD){
            e.stopPropagation();
            e.preventDefault();
            var isValid = true;
            var objVal =  angular.element(e.currentTarget).val();
            if(isFPDD){
                var tempId = obj;
                var tobj  = _.find(self.contractDocuments, function (aobj) {
                    return aobj.id == tempId || aobj.filekey == tempId;
                });
                obj = tobj;
            }
            obj[elId] = parseInt(objVal);

            if (objVal == undefined || objVal == null) {

                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html(intl_msg[8078]||intl_msg[24181]);
                isValid = false;
            }
           else if(objVal == ''){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html(intl_msg[8078]||intl_msg[24181]);
                isValid = false;
            }
            else if (parseInt(objVal) < 0 || parseInt(objVal) == 0) {
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html('Value for custom page numbering cannot be negative or zero');
                isValid = false;

            }
            else if(parseInt(objVal) > 100000 ){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html(intl_msg[24182]||'Value can not be grater than 10000');
                isValid = false;

            }else  if(elId == "numberOfPagesToExclude" && parseInt(objVal) > parseInt(obj.totalPages)){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html(intl_msg[25963]|| "Initial pages to exclude cannot be greater than Total Pages in Document");
                isValid = false;

            } else  if(elId == "startPageNumber" && parseInt(objVal) > parseInt(obj.totalPages)){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').show().html("start page number cannot be greater than Total Pages in Document");
                isValid = false;

            } else {
                angular.element(e.currentTarget).closest('.jx-' + elId).find('.errorMessage').hide().html('');
                angular.element(e.currentTarget).closest(".error_holder").removeClass("error_text");
            }
            if(!isValid){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('input').addClass('errorClass');
            } else {
                angular.element(e.currentTarget).closest('.jx-' + elId).find('input').removeClass('errorClass');
            }
            if(!isValid){
                angular.element(e.currentTarget).closest('.jx-' + elId).find('input').addClass('errorClass');
                angular.element(document.querySelector("#jx-treeDoc-"+obj.filekey)).find('.list-hover').addClass('errorClass');
                angular.element(document.querySelector("#jx-treeDoc-"+obj.id)).find('.list-hover').addClass('errorClass');

            } else {
                angular.element(e.currentTarget).closest('.jx-' + elId).find('input').removeClass('errorClass');
                angular.element(document.querySelector("#jx-treeDoc-"+obj.filekey)).find('.list-hover').removeClass('errorClass');
                angular.element(document.querySelector("#jx-treeDoc-"+obj.id)).find('.list-hover').removeClass('errorClass');
            }
            self.isPropertiesValid = isValid;
        }
        /**********************************************************************************************************/

    /***** toggleDocEditTemplate : function to toggle doc edit view *************************/
    this.toggleDocEditTemplate = function (val,e) {
        if(e != undefined && angular.element(e.currentTarget).hasClass('disabled')){
            return false;
        }
        self.showDoctreeTemplate = val;
        if(!val){
            docEditNeedSave = val;
        }
        if(self.pageType == 'create' || self.pageType == 'clone' || self.pageType == 'globalCreate'){
            if(!val){
                self.showfileaction = false;
            }
            var parentConName = (angular.element('.jx-parentForm').scope().data.name.values) ? angular.element('.jx-parentForm').scope().data.name.values : (intl_msg[28518]?intl_msg[28518]:'Untitled');
            angular.element('#jx-parentContractName').html(parentConName);
            angular.element('#jx-parentContractName').prepend('<i class="icon-folder"></i>');
            if(self.otherContract){
                angular.element('#jx-parentContractName').find('.icon-folder').addClass('otherFolder');
            }
        }
    };

    this.getContractNameOrTitle = function(){
        return document.querySelector(".selectedNode a span")?.textContent;
    };

    this.resizeImportFromCDRTable = function(){
        if($(".importFromCdr [my-table]").length>1) {
            setTimeout(function () {
                $(".importFromCdr [my-table]").eq(1).dataTable().fnAdjustColumnSizing(false);
            }, 300)
        }else{
            var pEl = $(".modal-dialog .content_container").eq(0);
            $compile($(".importFromCdr [my-table]"))(pEl.scope());
        }
    }

    this.attachSelectedDocRowsInDocuments = function($scope){
        var tableSc = $(".importFromCdr [my-table]").eq(1).scope(),
            selectedRowData = [],
            checkboxId = tableSc.queryNameToIdMapForColumns.checkbox,
            classificationId = tableSc.queryNameToIdMapForColumns.classification,
            documentnameId = tableSc.queryNameToIdMapForColumns.documentname;
        if(tableSc.selectedCheckBoxes && tableSc.selectedCheckBoxes.length){
            tableSc.tableServerData.forEach(function(item,index){
                if(item[checkboxId] && item[checkboxId].value && tableSc.selectedCheckBoxes.indexOf(item[checkboxId].value.split(":;")[0])>-1){
                    var classy = {
                        "search": [true, "Search"],
                        "download": [true, "Download"],
                        "viewerAvailable": [true,"Viewer Available"],
                        "finance": [false,intl_msg[4566]],
                        "legal": [false, intl_msg[4567]],
                        "businessCase": [false,intl_msg[4568]]
                    };
                    if(item[classificationId] && item[classificationId].value){
                        var arr = item[classificationId].value.toLowerCase().split(",");
                        if(arr.indexOf(intl_msg[4568].toLowerCase()) > -1)
                            classy.businessCase[0] = true;
                        if(arr.indexOf(intl_msg[4566].toLowerCase()) > -1)
                            classy.finance[0] = true;
                        if(arr.indexOf(intl_msg[4567].toLowerCase()) > -1)
                            classy.legal[0] = true;
                    }
                    var obj = {
                        "classification": classy,
                        "name": item[documentnameId].value,
                        "id": item[checkboxId].value.split(":;")[0],
                        "showPopup": false,
                        "extension": item[documentnameId].value.split('.')[item[documentnameId].value.split('.').length - 1].toLowerCase(),
                        isDisabled: true
                    };
                    selectedRowData.push(obj);
                }
            })
        }
        this.importedDocsFromCdr =  selectedRowData;

        let newFormData = {
            files: this.importedDocsFromCdr,
            actionType:"updateDefaultDocList"
        }
        window.sarc.channelBroadcast("reactDynamicForms",newFormData,`dfSubscriptions_${$scope.globalData.dynamicFormId}`);
    }

    this.openProps = function(hidden,id,e){
        if(!hidden && e){
            var querySelectorId = "fileProperties_popCont_" + id ,
                parentDivElem =  "fileProperties_" + id ;
            SirionUtils.openDropDownUpwards(parentDivElem , querySelectorId , 10);
        }
    }

        this._compareJSON = function(){
            var _flag = true;
            /* http://jira.sirionlabs.office/browse/SIR-200709 */
            if( ( self.pageType == 'create' || self.pageType == 'globalCreate' ) ||
                (SirionUtils.isEmpty(self.contractDocuments) && SirionUtils.isEmpty(self.contractDocumentsCopy) ) ){
                return _flag;
            }
            else{
                _flag = SirionUtils.compareJson(self.contractDocuments,self.contractDocumentsCopy);
            }
            return _flag;
        };
        /**************************************************************************************************/
        this.checkAllChildDoc = function(e){
            var parentDoc = angular.element('.jx-rootElm');
            if(angular.element(e.currentTarget).prop('checked')){
                parentDoc.find('.jx-doc-checkbox').prop('checked', true);
                parentDoc.find('.jx-childElm').addClass('jx-selectedDoc');
            }else{
                parentDoc.find('.jx-doc-checkbox').prop('checked', false);
                parentDoc.find('.jx-childElm').removeClass('jx-selectedDoc');
            }
            updateFileOptions();
        };
        /********* setFilePropertiesDropDown : function to show file properties drop down ****************/
        this.setFilePropertiesDropDown = function (row, fromNewFileUpload=false) {
            self.documentIdField = self.getFieldByIdCopy('documentId');
            self.externalIdField = self.getFieldByIdCopy('externalId');
            var _currentTile;
            if (row) {
                _currentTile = row;
                for (var k = 0; k < self.uploadDocPropCopy.length; k++) {
                    if (self.hiddenUploadDocPropName.indexOf(self.uploadDocPropCopy[k].name) > -1) {
                        self.uploadDocPropCopy[k]["isHidden"] = true;
                    }
                    if (_currentTile.hasOwnProperty(self.uploadDocPropCopy[k].name)) {
                        self.uploadDocPropCopy[k]["isChecked"] = _currentTile[self.uploadDocPropCopy[k].name];
                        setStatusOfFileProp(self.uploadDocPropCopy[k],_currentTile);
                        if(self.uploadDocProp[k].name == "customNumbering" ){
                            if(self.uploadDocProp[k]["displayMode"] == "display"){
                                self.uploadDocProp[k]["isHidden"] = true;
                                self.showCustomNumbering = false;
                            }
                            else if(_currentTile.referenced || _currentTile.totalPages == null){
                                self.uploadDocProp[k]["isHidden"] = true;
                                self.showCustomNumbering = false;
                            }
                            else if(_currentTile.filekey ){
                                self.uploadDocProp[k]["isHidden"] = false;
                            }
                            else{
                                self.uploadDocProp[k]["isHidden"] = false;
                            }

                        }
                        else if(  self.uploadDocProp[k].name == "download"  ){
                            if( (!self.uploadDocProp[k]["isChecked"])){
                                self.downloadContractDocOption = false;
                            }
                            if(self.uploadDocProp[k]["isHidden"]){
                                self.uploadDocProp[k]["isHidden"] = !self.uploadDocProp[k]["isHidden"];
                            }
                        }
                    } else {
                        self.uploadDocPropCopy[k]["isChecked"] = false;
                        if(  self.uploadDocProp[k].name == "download"   ){
                            if(  !(self.uploadDocProp[k]["isChecked"])){
                                self.downloadContractDocOption = false;
                            }

                        if(self.uploadDocProp[k]["isHidden"]){
                            self.uploadDocProp[k]["isHidden"] = !self.uploadDocProp[k]["isHidden"];
                        }
                    }
                    if (self.customNumberingFields.indexOf(self.uploadDocProp[k].name) > -1) {
                        _currentTile[self.uploadDocProp[k].name] = "";}
                    /*
                    else {
                        _currentTile[self.uploadDocProp[k].name] = false;
                    }*/
                    setStatusOfFileProp(self.uploadDocPropCopy[k], _currentTile);

                    }
                }

            }
            else {
                for (var k = 0; k < self.uploadDocProp.length; k++) {
                    if (self.selectedTileArray.length == 1) {
                        _currentTile = self.selectedTileArray[0];
                        if (self.hiddenUploadDocPropName.indexOf(self.uploadDocProp[k].name) > -1) {
                            self.uploadDocProp[k]["isHidden"] = true;
                        }
                        if (_currentTile.hasOwnProperty(self.uploadDocProp[k].name)) {
                            self.uploadDocProp[k]["isChecked"] = _currentTile[self.uploadDocProp[k].name];
                            setStatusOfFileProp(self.uploadDocProp[k],_currentTile);
                            if(self.uploadDocProp[k].name == "customNumbering" ){
                                if(self.uploadDocProp[k]["displayMode"] == "display"){
                                    self.uploadDocProp[k]["isHidden"] = true;
                                    self.showCustomNumbering = false;
                                }
                                else if(_currentTile.referenced || _currentTile.totalPages == null){
                                    self.uploadDocProp[k]["isHidden"] = true;
                                    self.showCustomNumbering = false;
                                }
                                else if(_currentTile.filekey ){
                                    self.uploadDocProp[k]["isHidden"] = false;
                                }
                                else{
                                    self.uploadDocProp[k]["isHidden"] = false;
                                }

                        }
                        else if(  self.uploadDocProp[k].name == "download"  ){
                            if( (!self.uploadDocProp[k]["isChecked"] || self.selectedTileArray[0].filekey )){
                                self.downloadContractDocOption = false;
                             }
                            if(self.uploadDocProp[k]["isHidden"]){
                                self.uploadDocProp[k]["isHidden"] = !self.uploadDocProp[k]["isHidden"];
                            }
                        }
                        else if(self.uploadDocProp[k].name == "businessCase" ){
                            var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
                            if(preselectionExists){
                                self.uploadDocProp[k]["isChecked"] = true;
                            }
                        }
                    } else {
                            if(fromNewFileUpload && self.uploadDocProp[k].properties && self.uploadDocProp[k].properties.defaultValue){
                                self.uploadDocProp[k]["isChecked"] = self.uploadDocProp[k].properties.defaultValue;
                                if(self.uploadDocProp[k].name != 'viewerAvailable'){
                                    _currentTile[self.uploadDocProp[k].name] = true;
                                }
                            }else {
                                self.uploadDocProp[k]["isChecked"] = false;
                            }
                        if(self.uploadDocProp[k].name == "businessCase" ){
                            var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
                            if(preselectionExists){
                                self.uploadDocProp[k]["isChecked"] = true;
                            }
                        }
                        if(  self.uploadDocProp[k].name == "download"  || self.selectedTileArray[0].filekey  ){
                            if(  !(self.uploadDocProp[k]["isChecked"])){
                                self.downloadContractDocOption = false;
                            }
                            if(self.uploadDocProp[k]["isHidden"]){
                                self.uploadDocProp[k]["isHidden"] = !self.uploadDocProp[k]["isHidden"];
                            }
                        }
                        if (self.customNumberingFields.indexOf(self.uploadDocProp[k].name) > -1) {
                            _currentTile[self.uploadDocProp[k].name] = '';
                        }
                        if(self.uploadDocProp[k].name == "metadataAutoExtract" ){
                            const sc = $('ng-view').scope();
                            if(sc?.ttdEnabled && self.hasMetadataAutoExtractPermission) {
                                self.uploadDocProp[k]["isChecked"] = true;
                            }
                        }

                        setStatusOfFileProp(self.uploadDocProp[k],_currentTile);
                    }
                }
                else{
                    var extArr =_.uniq(self.selectedTileArray.map(function (fobj) {return fobj.extension;}));
                    var hideSearch = false;
                    var hideViewer = false;
                    var hideAutoExtract = false;
                    var propVal = self.selectedTileArray.map(function (fobj) {return fobj[self.uploadDocProp[k].name];});
                    var propValWithExt = self.selectedTileArray.map(function (fobj) {return {'checkedval':fobj[self.uploadDocProp[k].name],'ext':fobj.extension};});
                    if(fromNewFileUpload && _.get(self.uploadDocProp[k],'properties.defaultValue')){
                        self.uploadDocProp[k]["isChecked"] = self.uploadDocProp[k].properties.defaultValue;
                        // This check was added against UI-9602, but it is causing a new issue UI-29348
                        // if(self.uploadDocProp[k].name != 'viewerAvailable'){
                            self.selectedTileArray = self.selectedTileArray.map(file =>{
                                file[self.uploadDocProp[k].name] = true;
                                return file;
                            })
                        // }
                    } else {
                        self.uploadDocProp[k]["isChecked"] = false;
                    }
                    if (self.uploadDocProp[k].name == "search") {
                        for (var i = 0; i < extArr.length; i++) {
                            if (searchableExtensions.indexOf(extArr[i]) == -1) {
                                hideSearch = true;
                            }
                        }
                        if(hideSearch){
                            self.uploadDocProp[k]["isHidden"] = true;
                        }else{
                            self.uploadDocProp[k]["isHidden"] = false;
                        }
                         propValWithExt = _.filter(propValWithExt,function(o){return searchableExtensions.indexOf(o.ext) >-1 ;});

                        } else if (self.uploadDocProp[k].name == "viewerAvailable") {
                            for (var i = 0; i < extArr.length; i++) {
                                if (viewerExtensions.indexOf(extArr[i]) == -1) {
                                    hideViewer = true;
                                }
                            }
                            if (hideViewer) {
                                self.uploadDocProp[k]["isHidden"] = true;
                            } else {
                                self.uploadDocProp[k]["isHidden"] = false;
                            }
                         propValWithExt = _.filter(propValWithExt,function(o){return viewerExtensions.indexOf(o.ext) >-1 ;});

                        }else if (self.uploadDocProp[k].name == "autoExtract") {
                            for (var i = 0; i < extArr.length; i++) {
                                if(["doc", "dot", "docx", "docm", "dotx", "dotm", "docb"].indexOf(extArr[i]) == -1 || !self.hasAutoExtractEntitiesPermission){
                                    hideAutoExtract = true;
                                }else{
                                    hideAutoExtract = false;
                                }
                            }
                            if(hideAutoExtract){
                                self.uploadDocProp[k]["isHidden"] = true;
                            }else{
                                self.uploadDocProp[k]["isHidden"] = false;
                            }
                        }
                        else if(self.uploadDocProp[k].name == "customNumbering" ){
                            self.showCustomNumbering = false;
                            if(self.uploadDocProp[k]["displayMode"] != "editable"){
                                self.uploadDocProp[k]["isHidden"] = true;
                            }
                        }
                        if(self.hiddenUploadDocPropName.indexOf(self.uploadDocProp[k].name) == -1){
                            /*if((propVal.indexOf(undefined) > -1 || propVal.indexOf(false) > -1){
                                self.uploadDocProp[k]["isChecked"] = false;
                                if(  self.uploadDocProp[k].name == "download" ){
                                    self.downloadContractDocOption = false;
                                    //self.uploadDocProp[k]["isHidden"] = true;
                                }

                            }*/
                            if(_.findIndex(propValWithExt, function(o) { return o.checkedval == false ||  o.checkedval == undefined; })>-1){
                                self.uploadDocProp[k]["isChecked"] = false;
                                if(  self.uploadDocProp[k].name == "download" ){
                                    self.downloadContractDocOption = false;
                                    //self.uploadDocProp[k]["isHidden"] = true;
                                }
                            }
                            else{
                                self.uploadDocProp[k]["isChecked"] = true;
                            }
                        }
                        if (self.hiddenUploadDocPropName.indexOf(self.uploadDocProp[k].name) > -1) {
                            self.uploadDocProp[k]["isHidden"] = true;
                        }
                        if(self.uploadDocProp[k].name == "businessCase" ){
                            var preselectionExists = dataManipulationService.validateClientSpecificOptionSelection();
                            if(preselectionExists){
                                self.uploadDocProp[k]["isChecked"] = true;
                            }
                        }
                    }
                    let rowElem = self.filePropList && self.filePropList.find( (prop) =>{return prop.name == self.uploadDocProp[k].name});
                    if(rowElem){
                        rowElem.isChecked = self.selectedTileArray
                            .filter(doc =>!this.setPropDisabled(self.uploadDocProp[k].name, doc.extension))
                            .every(doc => doc[self.uploadDocProp[k].name]);
                    }
                }
            }

        };

        this.getFieldByIdCopy  = function (name) {
            return _.filter(self.uploadDocPropCopy, function(ob) {
                return ob.type == 'text' && ob.name == name;
            });
        };

        this.resetServiceVar = function(){
            self.showDoctreeTemplate = false;
            self.showImportFromCdr = false;
            self.importedDocsFromCdr = [];
            self.uploadDocLayout = '';
            self.showfileaction = false;
            self.selectedTileArray = [];
            self.showCustomNumbering = false;
            self.showFileProperties = false;
            self.downloadContractDocOption = false;
            self.deleteItemOption = false;
            self.customNumberingProps = {};
            self.showReplace = false;
            self.showUploadChild = false;
            self.uploadDocPropName= [];
            self.uploadDocProp = [];
            self.uploadDocPropCopy =[];
            self.otherFolder = false;

        }

        this.isModalPopUpVisible = function(){
            return ($(".modal-content").is(':visible'));
        }
        this.disableAEentities = function(id, autoExtractVal, isNewUpload){
            const that = this; // ShowPage Scope
            if(autoExtractVal && isNewUpload && !that.ttdEnabled){
                return
            }
            var item = $("#"+id);
            var li = item[0].children[0].getElementsByTagName("li");
            for(var i=0;i< li.length;i++ ){
                if(li[i].childNodes[5]){
                    var txt = li[i].childNodes[5].innerText;
                    var input = li[i].getElementsByTagName('input');
                    if(autoExtractVal && isNewUpload && that.ttdEnabled){
                        if(autoExtractVal && txt === intl_msg[28990]){
                            input[0].setAttribute("disabled", "disabled");
                            li[i].style.opacity = 0.5;
                        }
                    }else {
                        if((txt === intl_msg[32460]|| txt === intl_msg[32461])||(autoExtractVal && txt === intl_msg[28990])){
                            input[0].setAttribute("disabled", "disabled");
                            li[i].style.opacity = 0.5;
                        }
                    }
                }
            }
        }
        this.setPropDisabled = function(propName,ext){
            ext = (ext || "").toLowerCase();
            const sc = $('ng-view').scope();
            if (propName == "search") {
                if (searchableExtensions.indexOf(ext) == -1) {
                    return true;
                } else {
                    return false;
                }
            } else if (propName == "viewerAvailable") {
                if (viewerExtensions.indexOf(ext) == -1) {
                    return true;
                } else {
                    return false;
                }
            } else if (propName == "autoExtract") {
                if ( self.hasAutoExtractEntitiesPermission
                    && (ext && ["doc", "dot", "docx", "docm", "dotx", "dotm", "docb"].indexOf(ext)> -1) ) {
                    return false;
                } else {
                    return true;
                }
            } else if (propName == "metadataAutoExtract"){
                if(self.hasMetadataAutoExtractPermission){
                    return false
                }else{
                    return true;
                }
            }else if(propName == "customNumbering"){
                if(self.allowedExtForCustomNumbering.indexOf(ext.toLowerCase()) == -1){
                    return true;
                }else{
                    return false;
                }
            }
            else{
                return false;
            }
        }
        this.openFilePropertiesModal = function(newFiles, selectedFiles, selectedDocs){
            self.docUploadFlow = !!newFiles;
             self.filePropList = angular.copy(_.filter(self.uploadDocProp, function (ob) {
                return (ob.type == 'checkbox');
            }));
            if(newFiles){
                self.selectedFilesForEdit = self.newlyAppendFileList;
                self.selectedFilesForEditCopy = angular.copy(self.selectedFilesForEdit);
                //updateFileOptions(self.selectedFilesForEdit);
                self.selectedTileArray = self.selectedFilesForEdit;
                self.newlyuploadedFiles = true;
                self.setFilePropertiesDropDown(null, true);
            }else{
                var selectedArr  = selectedDocs ? selectedDocs : _.map(angular.element('.jx-selectedDoc:not(".jx-filesToBeDeleted")'), function (o) {
                    return angular.element(o).data('cid');
                });
                if(selectedFiles){
                    self.selectedFilesForEdit = selectedFiles;
                    self.selectedTileArray = self.selectedFilesForEdit;
                }else{
                self.selectedFilesForEdit =  _.intersectionWith(self.contractDocuments, selectedArr, function (aobj, oobj) {
                    return aobj.id == oobj || aobj.filekey == oobj;
                });
                }
                if(self.selectedFilesForEdit?.length) {
                    self.selectedFilesForEdit = self.selectedFilesForEdit.map(file => {
                        file.displayName = unescapeHtml(file["name"]?.replace(/&amp;/g, "&"));
                        return file;
                    })
                }
                self.selectedFilesForEditCopy = angular.copy(self.selectedFilesForEdit);
                if(selectedDocs) {
                    self.selectedTileArray = self.selectedFilesForEdit;
                }
                self.setFilePropertiesDropDown();
            }

            /*self.filePropList = _.filter(self.uploadDocProp, function (ob) {
                return (ob.type == 'checkbox') && (!ob.properties.hasOwnProperty('triggerCustomPages'));
            });*/
            self.documentIdField = self.getFieldById('documentId');
            self.externalIdField = self.getFieldById('externalId');
            self.customNumberingFPList = _.filter(self.uploadDocProp, function (ob) {
                const dependentFields = [].concat(ob.dependentField || ob.dependentFields);
                return dependentFields.includes('customNumbering');
            });
            self.tempfilePropList = angular.copy(self.filePropList);
            if(self.modalInstance == undefined){
            self.modalInstance = $modal.open({
                templateUrl: $rootScope.createHtmlUrl("ui2.0/documentTree/saveFilePropertiesTemplate.html"),
                size: "lg",
                backdrop: "static",
                //keyboard: false,
                controller:'saveFilePropController',
               // scope:$scope,
                windowClass: "saveFPDialog",
                resolve : {
                   // scopeObj = self.selectedFilesForEdit;
                    docTreeService : function(){
                        return self;
                    }
                    //docTreeService.selectedFilesForEdit = self.selectedFilesForEdit;
                }
            });
            self.modalInstance.opened.then(function () {
                self.fpmodalOpen = true;
            },function(){

            });

            self.modalInstance.closed.then(function(){
                self.docUploadFlow = false;
                if(self.shouldAppendUploadedFilesOnModalClose){
                    for(var i =0;i<self.selectedFilesForEdit.length;i++){
                        self.appendNewFileToTree(self.selectedFilesForEdit[i]);
                    }
                    self.selectedFilesForEdit = [];
                    self.newlyAppendFileList = [];
                    self.newlyuploadedFiles = false;
                    self.shouldAppendUploadedFilesOnModalClose = false;
                    self.selectedTileArray = [];
                }
                var elm;
                for(var i = 0; i<self.selectedTileArray.length;i++ ){
                    elm =  angular.element('#jx-treeDoc-'+self.selectedTileArray[i].id).length ? angular.element('#jx-treeDoc-'+self.selectedTileArray[i].id) : angular.element('#jx-treeDoc-'+self.selectedTileArray[i].filekey);
                    elm.find('.jx-doc-checkbox').prop('checked',false);
                    elm.removeClass('jx-selectedDoc');

                }
                angular.element('.jx-rootElm').find('.jx-doc-checkbox:first').prop('checked',false);
                self.showfileaction = false;
                self.selectedTileArray = [];
            });

            // we want to update state whether the modal closed or was dismissed,
            // so use finally to handle both resolved and rejected promises.
                self.modalInstance.result.then(function(){
                    if(!self.saveFpProp){
                    resetPropOnDialogClose();
                    }else{
                        self.fpmodalOpen = false;
                        self.shouldAppendUploadedFilesOnModalClose = !!self.newlyuploadedFiles;
                        self.selectedFilesForEditCopy = [];
                        self.saveFpProp = false;
                        delete self.modalInstance;
                    }
                },function(){
                    resetPropOnDialogClose();
                });
                function removeNewlyUploadedFilesOnCancel(){
                    var filesToRemove = (self.selectedFilesForEditCopy && self.selectedFilesForEditCopy.length)
                        ? self.selectedFilesForEditCopy
                        : (self.newlyAppendFileList || []);
                    var file, treeId, i;
                    for (i = 0; i < filesToRemove.length; i++) {
                        file = filesToRemove[i];
                        treeId = file.id || file.filekey;
                        if (treeId) {
                            angular.element('#jx-treeDoc-' + treeId).remove();
                        }
                    }
                    self.contractDocuments = _.filter(self.contractDocuments, function (doc) {
                        return !_.some(filesToRemove, function (f) {
                            if (f.filekey && doc.filekey) {
                                return f.filekey === doc.filekey;
                            }
                            if (f.id && doc.id) {
                                return f.id === doc.id;
                            }
                            if (f.key && doc.key) {
                                return f.key === doc.key;
                            }
                            return false;
                        });
                    });
                    self.syncContractDocumentsToReact(self.contractDocuments);
                    self.selectedFilesForEdit = [];
                    self.newlyAppendFileList = [];
                    self.newlyuploadedFiles = false;
                    self.shouldAppendUploadedFilesOnModalClose = false;
                }
                function resetPropOnDialogClose(){
                    if (self.newlyuploadedFiles) {
                        removeNewlyUploadedFilesOnCancel();
                    } else {
                        self.selectedFilesForEdit= angular.copy(self.selectedFilesForEditCopy);
                        self.contractDocuments = _.unionWith(self.selectedFilesForEdit,self.contractDocuments, function (aobj, oobj) {
                            if(aobj.hasOwnProperty('id') && oobj.hasOwnProperty('id')){
                                return (aobj.id == oobj.id);
                            }else if(aobj.hasOwnProperty('filekey') && oobj.hasOwnProperty('filekey')){
                                return (aobj.filekey == oobj.filekey);
                            }

                        });
                    }
                    self.filePropList = angular.copy(self.tempfilePropList);
                    self.fpmodalOpen = false;
                    self.selectedFilesForEditCopy = [];
                    delete self.modalInstance;
                }
            /*self.modalInstance.result.finally(function (selectedItem) {
                self.fpmodalOpen = false;
                self.selectedFilesForEditCopy = [];
                delete self.modalInstance;
            });*/

            }
        };

        this.getFieldById = function (name) {
            return _.filter(self.uploadDocProp, function(ob) {
                return ob.type == 'text' && ob.name == name;
            });
        };

        this.isCustomNumberingFieldVisible = function(files,_dependentFields) {
            const dependentFields = [].concat(_dependentFields);
            const show = !!dependentFields.find(field => files[field]);
            return show;
        }
        /********
         * This is to handle {Remove auto extraction if not permitted rather than disabled }
         * http://jira.sirionlabs.office/browse/SIR-200014  *************/
        this.handleHideShow = function(_row){
            var retval = true;
            if(_row.displayMode =='display'){
                retval = false;
            }
            else{
                if (_row.name == "autoExtract") {
                    retval = self.hasAutoExtractEntitiesPermission;
                }
                else{
                    retval = true;
                }
            }

            return retval;
        };


        /**********************************************************************************************************************/

        /************************************ || END OF PUBLIC FUNCTIONS || **************************************/

        /************************************ || BEGINNING OF PRIVATE FUNCTIONS || **************************************/
        /****** renameReplaceAjaxCall : http call to rename/replace existing documents ********/
        function renameReplaceAjaxCall(objectToPost) {
            return $http({
                dataType: "json",
                data: objectToPost,
                contentType: "application/json;charset=UTF-8",
                method: 'POST',
                url: appName + "/tblcontractdocuments/replace"
            });
        }

        /**** setStatusOfFileProp : function to set file properties status ***************************/
        function setStatusOfFileProp(fProp,_currentTile,propChecked){
            const ext = (_currentTile.extension || "").toLowerCase();
            const sc = $('ng-view').scope()
            if (fProp.name == "search") {
                if (searchableExtensions.indexOf(ext) == -1) {
                    fProp["isHidden"] = true;
                    _currentTile[fProp.name] = false;
                } else {
                    fProp["isHidden"] = false;
                    if(propChecked != undefined){
                        _currentTile[fProp.name] = propChecked;
                    }else{
                        _currentTile[fProp.name] = fProp.isChecked;
                    }

                }

            } else if (fProp.name == "viewerAvailable") {
                if (viewerExtensions.indexOf(ext) == -1) {
                    fProp["isHidden"] = true;
                    _currentTile[fProp.name] = false;
                } else {
                    fProp["isHidden"] = false;
                    if(propChecked != undefined){
                        _currentTile[fProp.name] = propChecked;
                    }else{
                        _currentTile[fProp.name] = fProp.isChecked;
                    }
                }

            } else if (fProp.name == "autoExtract") {
                if ((!self.hasAutoExtractEntitiesPermission) || (_currentTile.extension && !["doc", "dot", "docx", "docm", "dotx", "dotm", "docb"].indexOf(ext)> -1 )) {
                    fProp["isHidden"] = true;
                } else {
                    fProp["isHidden"] = false;
                    if(propChecked != undefined){
                        _currentTile[fProp.name] = propChecked;
                    }else{
                        _currentTile[fProp.name] = fProp.isChecked;
                    }
                }

            }else if (fProp.name == "metadataAutoExtract" && sc?.ttdEnabled && self.hasMetadataAutoExtractPermission) {
                fProp["isHidden"] = false;
                if(propChecked != undefined){
                    _currentTile[fProp.name] = propChecked;
                }else{
                    _currentTile[fProp.name] = fProp.isChecked;
                }
            }


            if (fProp.displayMode == 'display') {
                fProp["isHidden"] = true;
            }

        }
        /******************************************************************************************************************/

        /***** isLinkPresent : function to check for the presence of link ******/
        function isLinkPresent() {
            var retVal = false;
            for (var x = 0; x < self.selectedTileArray.length; x++) {
                if (self.selectedTileArray[x].extension
                    && self.selectedTileArray[x].extension == "link") {
                    retVal = true;
                    break;
                }
            }
            return retVal;
        }

        /*****************************************************************************************/

        /******** getDocTree : function to create the document tree of n level hierarchy ***********/
        function getDocTree(parentID) {
            return self.contractDocuments.filter(function (node) {
                return (node.parentId == parentID && node.fileAction != '3');
            }).map(function (node) {
                var exists = self.contractDocuments.some(function (childNode) {
                    if (node.hasOwnProperty('filekey')) {
                        return childNode.parentId == node.filekey;
                    } else if (node.hasOwnProperty('id')) {
                        return childNode.parentId == node.id;
                    }
                });
                var subMenu = '';
                if (exists) {
                    var subMenuHtm;
                    if (node.hasOwnProperty('filekey')) {
                        subMenuHtm = getDocTree(node.filekey)
                    } else {
                        subMenuHtm = getDocTree(node.id);
                    }
                    subMenu = angular.element('<ul/>', {
                        'class': 'child-doc-list'
                    }).append(subMenuHtm);
                } else {
                    subMenu = '';
                }
                if (subMenu != '') {
                    return docTreerenderer(node).append(subMenu).prepend('<i class="icon-down-arrow"></i>');
                } else {
                    return docTreerenderer(node).append(subMenu).addClass('no-child');
                }
            });
        }


        /**********************************************************************************************************/

        /************ docTreerenderer : renderer function to create the nodes of documnet tree ********************/
        function getHtmlForFileProp(elmObj,elmId){
            var noOfpagestoExclude = SirionUtils.isEmpty(elmObj.numberOfPagesToExclude) ? null : elmObj.numberOfPagesToExclude;
            var startPgNum = SirionUtils.isEmpty(elmObj.startPageNumber)? null: elmObj.startPageNumber;
            var documentId = elmObj.documentId ? elmObj.documentId : "";
            var htmlForFileProperties = '<ul style="position: absolute;max-height:65vh;margin-bottom: 10px;" ' +
                'id="fileProperties"  class="fileProperties drop-down doc-upload">\n' +
                '                                        <li ng-repeat="(key, row) in docTreeService.uploadDocPropCopy track by key"\n' +
                '                                        ng-if="!row.isHidden && row.type==\'checkbox\'" ng-hide="row.displayMode == display" class="filePropertiesRow-{{$index}}" \n' +
                '                                        ng-class="">\n' +
                '                                        <input class="show_alter_image"\n' +
                '                                               type="checkbox"\n' +
                '                                               ng-model="row.isChecked"  \n' +
                '                                               ng-click="updateContractDocObj($event,row,true)"\n' +
                'ng-disabled = "{{docTreeService.setPropDisabled(row.name,\''+elmObj.extension+'\')}}"\n'+
                'ng-class="{\'show_alter_image_disabled\': docTreeService.setPropDisabled(row.name,\''+elmObj.extension+'\')}"\n'+
                '                                               style="margin-top:1px!important;margin-left: -5px!important;"/>\n' +
                '                                        <span></span>\n' +
                '                                        <small style="font-size: 14px;color: #666666;" title="{{row.name}}">{{row.label}}</small>\n' +
                '                                    </li>\n' +
                '<li ng-if="!docTreeService.setPropDisabled(\'customNumbering\',\''+elmObj.extension+'\')" ng-show="'+elmObj.customNumbering+'" class="jx-cnfieldDD cnfieldDD">\n'+
                '<div class="totalNumberPages"><label>Total Pages - '+elmObj.totalPages+'</label></div>\n'+
                '<div class="jx-startPageNumber"><label>{{intl_msg[26657]}}</label>\n'+
                '<input type="number" name="startPageNumber" maxlength="6" value="'+startPgNum+'" ng-blur="docTreeService.setCustomNumberingProps($event,'+startPgNum+',\''+elmId+'\',\'startPageNumber\',true)"/><p class="errorMessage"></p></div>\n'+
                '<div class="jx-numberOfPagesToExclude"><label>{{intl_msg[26656]}}</label>\n'+
                ' <input type="number" name="initialPagesToExclude" maxlength="6" value="'+noOfpagestoExclude+'" ng-blur="docTreeService.setCustomNumberingProps($event,'+noOfpagestoExclude+',\''+elmId+'\',\'numberOfPagesToExclude\',true)"/><p class="errorMessage"></p></div>\n'+
                '</li>\n'+
                '<li ng-repeat="(key, row) in docTreeService.documentIdField track by key" class="filePropertiesRow-{{$index}} cnfieldDD" ng-class="">\n' +
                '<div class="uploadedFileDocIDWrapper">\n' +
                '                                        <label title="{{row.name}}">{{row.label}}:</label>\n' +
                '  <span id="{{row.name}}_{{documentId}}" class="uploadedFileDocID"/>' + documentId + '</span></div>\n' +
                '                                    </li>\n' +
                //'<li class="btn-grp jx-cnfieldDD" ng-show="'+elmObj.customNumbering+'"><a class="btn">Cancel</a><a class="btn">Done</a></li>\n'+
                '                                </ul>';


            return htmlForFileProperties;
        }
        this.disableMDClauseObligation = function(name, file){
            if(name == 'mdClausePorting' || name == 'obligationPorting'){
                const sc = $('ng-view').scope();
                if(!file){
                    // let metadataAutoExtractField = self.filePropList.find( f => f.name == "metadataAutoExtract");
                    // if(!metadataAutoExtractField?.isChecked)
                    //     return true;
                    const hasNewFile = self.selectedFilesForEdit.find(f => !f.id);
                    if (!hasNewFile) {
                        const isMaeCheckedFromBackendForAll = (self.selectedFilesForEditCopy || []).every(f => f.metadataAutoExtract);
                        return isMaeCheckedFromBackendForAll;
                    }
                } else if(file?.id) {
                    const isMaeCheckedFromBackend = !!(self.selectedFilesForEditCopy || []).find(c => c.id == file.id)?.metadataAutoExtract;
                    return isMaeCheckedFromBackend;
                }  
            }
            if(name == 'metadataAutoExtract') {
                const metadataAutoExtractField = self.filePropList.find(f => f.name == "metadataAutoExtract");
                return metadataAutoExtractField?.isChecked == true || $('ng-view').scope()?.ttdEnabled;
            }
            return false;
        }
        function docTreerenderer(elmObj) {

        var obj = {};
        var elmId = elmObj.filekey != null ? elmObj.filekey : elmObj.id;
        var elmObjStr = escape(JSON.stringify(elmObj));
        obj.elmId = elmId;
        obj.download = elmObj.download;
        var elemKey = elmObj.filekey != null ? 'filekey' : 'id';
        var downloadStyle = (elmObj.hasOwnProperty('filekey')) ?'display:none':'';
        /*elmObj.displayNone = SirionUtils.isEmpty(downloadStyle)?false:true;*/
        var replaceStyle =  elmObj.hasOwnProperty('filekey') ? 'display:none' : '';
        var filePropertiesTempplate = '<div class="filePropertiesTempplate_'+elmId+'"><i class="icon-Gear-Settings-line" title="'+intl_msg[26658]+'"' +
            'outside-if-not=".filePropertiesSpan,.displayNone,.displayBlock,fileProperties" click-outside="closeFileProperties($event,\'' + elmObjStr + '' + '\')" data-ng-click="resetFileProperties($event,\'' + elmObjStr + '' + '\');" ></i>' +
            '<span class="displayNone filePropertiesSpan" id="fileProperties_'+elmId+'">' + getHtmlForFileProp(elmObj,elmId) + '</span></div>';
        var lis = angular.element('<li/>', {
            'class': 'jx-childElm',
            'id': 'jx-treeDoc-' + elmId,
            'data-cid': elmId,
            'ng-mouseenter':'docTreeService.hovered[\'' + elmId + '\'] = true',
            'ng-mouseleave':'docTreeService.hovered[\'' + elmId + '\'] = false'
        });
        lis.append(angular.element('<div/>', {
                'class': 'list-hover'
            })
                .append(angular.element('<input/>', {
                    'type': 'checkbox',
                    'ng-click': 'docTreeService.toggleFileaction($event)',
                    'class':'jx-doc-checkbox cursor-pointer'
                }))
                .append(angular.element('<span/>', {}))
                .append(angular.element('<small/>')
                    .prepend(angular.element('<em/>', {
                        'text': elmObj.documentId ? `${elmObj.name.replace(/&amp;/g, "&")} (${elmObj.documentId})` : elmObj.name.replace(/&amp;/g, "&"),
                        'ng-dblclick': 'docTreeService.makeDivEditable($event)',
                        'ng-blur': 'docTreeService.renameFile($event)',
                        'title': elmObj.name.replace(/&amp;/g, "&")
                    }))
                    .prepend(angular.element('<i/>', {
                        'class': 'icon-' + elmObj.extension.toLowerCase()
                    }))
                    .prepend((elemKey == 'filekey')? angular.element('<i/>', {
                        'class': 'newFile','text':intl_msg[29023]?intl_msg[29023]:'New'
                    }) : angular.noop())
                )
                .append(angular.element('<div/>', {
                        'class': 'hover-icons',
                        // 'ng-if': 'docTreeService.hovered[\'' + elmId + '\']'
                    })
                        .append((elmObj.extension != 'link') ? angular.element('<i/>', {
                                'class': 'icon-Upload-Child',
                                'ng-click': 'docTreeService.triggerFileUpload($event)',
                                'data-targetarea': 'withinelem',
                                    'title':intl_msg[26652]
                            })
                                : null
                        ).append(!elmObj.editBlocked ? angular.element('<i/>', {
                        'class': 'icon-edit',
                        'ng-click': 'docTreeService.makeFileRenamable($event)',
                        'title':intl_msg[27540]}) : null
                    ).append(angular.element('<i/>', {
                            'class': 'icon-Replace',
                            'ng-click': 'docTreeService.replaceFile($event)',
                            'style': replaceStyle,
                        'title':intl_msg[26653]}))
                        .append((elmObj.extension != 'link') ? angular.element(filePropertiesTempplate) : null)
                        .append((elmObj.extension != 'link' && elmObj.hasOwnProperty('id')) ? angular.element('<i/>', {
                            'class': 'icon-download',
                            'ng-click': 'docTreeService.downloadContractDoc($event,' + elmObj.id + ')',
                            'ng-show':'docTreeService.downloadHoverContractDocOptn(\'' +  elmObjStr+ '\')',
                            'style': downloadStyle,
                        'title':intl_msg[23733]}) : null)
                        .append(angular.element('<i/>', {
                            'class': 'icon-delete',
                            'ng-click': "deleteItem($event.target,undefined,true)",
                            'data-targetarea': 'withinelem',
                                'title':intl_msg[24252]
                        }))
                )
        );
        return lis;

        }
        function updateFileOptions(selectedTileArray){

            var selectedArr  =  _.map(angular.element('.jx-selectedDoc:not(".jx-filesToBeDeleted")'), function (o) {
                return angular.element(o).data('cid');
            });
            var selectedElm =  _.intersectionWith(self.contractDocuments, selectedArr, function (aobj, oobj) {
                return aobj.id == oobj || aobj.filekey == oobj;
            });
            self.selectedTileArray = selectedTileArray || selectedElm;
            self.deleteItemOption = true;
            if(self.selectedTileArray.length == 0){
                self.showfileaction = false;
            }else {
                self.showfileaction = true;
                if (self.selectedTileArray.length == 1) {
                    if (self.selectedTileArray[0].totalPages == null) {
                        self.customNumberingProps["disabled"] = true;
                        /*self.customNumberingProps["isHidden"] = true;*/
                    }
                    if (self.selectedTileArray[0].referenced && self.selectedTileArray[0]["totalPages"] > 0) {
                        self.customNumberingProps["disabled"] = true;
                        /*self.customNumberingProps["isHidden"] = true;*/
                    }
                    else {
                        self.customNumberingProps["disabled"] = false;
                    }
                    /*Copy Custom numbering properties */
                    self.showCustomNumbering = self.selectedTileArray[0].customNumbering;
                    self.customNumberingProps["totalPages"] = self.selectedTileArray[0]["totalPages"]!=false  ? self.selectedTileArray[0]["totalPages"] :"";
                    self.customNumberingProps["numberOfPagesToExclude"] = self.selectedTileArray[0]["numberOfPagesToExclude"]!=false? self.selectedTileArray[0]["numberOfPagesToExclude"] :"";
                    self.customNumberingProps["startPageNumber"] = self.selectedTileArray[0]["startPageNumber"]!=false ? self.selectedTileArray[0]["startPageNumber"] :"";



                    self.downloadContractDocOption = true;
                    self.showUploadChild = true;
                    self.showReplace = true;
                    self.showRename = true;
                    self.showFileProperties = true;
                    if (isLinkPresent()) {
                        self.showFileProperties = false;
                        self.downloadContractDocOption = false;
                        self.showUploadChild = false;
                        self.showCustomNumbering = false;
                    }
                    if(self.selectedTileArray[0].hasOwnProperty('filekey')){
                        self.showReplace = false;
                    }
                } else {
                    self.showCustomNumbering = false;
                    self.downloadContractDocOption = false;
                    self.showUploadChild = false;
                    self.showReplace = false;
                    self.showRename = false;
                    self.customNumberingProps["disabled"] = true;
                    if (isLinkPresent()) {
                        self.showFileProperties = false;
                    } else {
                        self.showFileProperties = true;
                    }
                }
                self.setFilePropertiesDropDown();
            }
        }



        /******************************************************************************************************************/
        $(document).on('click', '.icon-down-arrow,.icon-Left-Arrow', function (e) {
            if ($(this).closest('#jx-document-list').length) {
                $(this).closest('li').find('.child-doc-list').toggle();
                $(this).toggleClass('icon-down-arrow');
                $(this).toggleClass('icon-Left-Arrow');
            }
        });

        var cleanup1 = $rootScope.$on("enableExpand",function(e,data){

            $rootScope.enableExpand = true;
        });

        this.onCloseUploadLinkDialog = () => {
            self.uploadLink = [];
            self.uploadLink.push({
                'linkName': '',
                'link': ''
            });
        }

    }


    /***************************************** END OF docTreeService ****************************************************/

    /****** INJECTOR ARRAY OF docTreeService ****************************************************/
    docTreeService.$inject = ['$http', '$compile', '$timeout','$uibModal','$rootScope','dataManipulationService'];
})();
